import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { GoogleAnalyticsEventsService } from "../google-analytics-events.service";

@Component({
  selector: 'app-not-supported',
  templateUrl: './not-supported.component.html',
  styleUrls: ['./not-supported.component.scss']
})
export class NotSupportedComponent implements OnInit {
  deceased = this.appState.get();

  constructor(public appState: AppService, public googleAnalyticsEventsService: GoogleAnalyticsEventsService) {
  	this.appState = this.appState;

    this.googleAnalyticsEventsService.emitEvent("Inheritance-Calculator", "Not-Supported-Inheritance", this.deceased.gender, 1);
  }

  // Back Button
  back(event) {
  	window.history.back();
  	event.preventDefault();
  }

  ngOnInit() {
    document.location.href = 'level2-inheritors';
  }
}
